export const LANG_DEFAULT = 'uk';
export const LANGS = ['uk', 'ru'];
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const DJANGO_LANGUAGE = 'django_language';
export const ADMIN_ROLE = 'admin';
export const PSYCHOLOGIST_ROLE = 'psychologist';
export const CHECKOUT_STATUSES = {
  CREATED: 'CREATED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
};
export const PAGE_TEMPLATES = {
  POST: 'POST',
  DEFAULT: 'DEFAULT',
  PROBLEMS: 'PROBLEMS',
  COURSES: 'COURSES',
  CONSULTATIONS: 'CONSULTATIONS',
  SIMPLE: 'SIMPLE',
  DOROSLY_TEMY: 'DOROSLY_TEMY',
  PERSONALITIES: 'PERSONALITIES',
  PSY_TEST: 'PSY_TEST',
};
export const PAGE_TEMPLATES_ARRAY = [
  PAGE_TEMPLATES.DEFAULT,
  PAGE_TEMPLATES.SIMPLE,
  PAGE_TEMPLATES.POST,
  PAGE_TEMPLATES.PROBLEMS,
  PAGE_TEMPLATES.COURSES,
  PAGE_TEMPLATES.CONSULTATIONS,
  PAGE_TEMPLATES.DOROSLY_TEMY,
  PAGE_TEMPLATES.PERSONALITIES,
  PAGE_TEMPLATES.PSY_TEST,
];
export const NEWS_PREFIX = 'news';
export const PAGE_PREFIX = 'page';

export const PAGE_STATUSES = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};
export const PAGE_STATUSES_ARRAY = [
  PAGE_STATUSES.DRAFT,
  PAGE_STATUSES.PUBLISHED,
];

export const CONSULTATIONS_STATUSES = {
  scheduled: 'scheduled',
  provided: 'provided',
  canceled: 'canceled',
  bought: 'bought',
};
export const CONSULTATIONS_TYPES = {
  standard: 'standard',
  pair: 'pair',
  subscription: 'subscription',
  coop: 'coop',
  junior: 'junior',
  tester: 'tester',
  vip: 'vip',
};
export const CONSULTATIONS_TYPES_ARRAY = [
  CONSULTATIONS_TYPES.standard,
  CONSULTATIONS_TYPES.pair,
  CONSULTATIONS_TYPES.subscription,
  CONSULTATIONS_TYPES.junior,
  CONSULTATIONS_TYPES.tester,
  CONSULTATIONS_TYPES.vip,
];

export const TASK_STATUSES = {
  new: 'new',
  process: 'process',
  success: 'success',
  cancel: 'cancel',
};
export const TASK_STATUSES_ARRAY = [
  TASK_STATUSES.new,
  TASK_STATUSES.process,
  TASK_STATUSES.success,
  TASK_STATUSES.cancel,
];

export const FILTERS_TYPES = {
  approaches: 'approaches',
  requests: 'requests',
  specialization: 'specialization',
  problems: 'problems',
};
export const FILTERS_TYPES_ARRAY = [
  FILTERS_TYPES.approaches,
  FILTERS_TYPES.requests,
  FILTERS_TYPES.specialization,
  FILTERS_TYPES.problems,
];

export const FEATURES_TYPES = {
  Tag: 'Tag',
  Language: 'Language',
};
export const FEATURES_TYPES_ARRAY = [FEATURES_TYPES.Tag, FEATURES_TYPES.Language];

export const HOME_SLUG = 'home';
export const COLOR_SITE_TEXT_DEFAULT = '#262524';